export default __webpack_public_path__ + "static/lilnadas-cards-health-2-a36de7d4f5ada6865d6dd2a0508748b7.png";